module.exports = __webpack_public_path__ + "img/icon_close_default (1).f8393471.svg";